// 取得履歴の種別セル（登記・図面）の (フィールド, 表示名) 対を一元管理する。
// テーブル列生成（makeHistoryGridColDef）と登記取得日フォールバック/明細（pictureReceivedDate）の
// 二重定義を解消し、テーブル列順・登記取得日フォールバック順をこの 1 箇所に集約する。

/** DownloadCell を表示する種別セル列のフィールド（HistoryPictureCell 型のキー）。 */
export type PictureCellField =
  | "zenbujiko"
  | "shoyushajiko"
  | "chisekisokuryozu"
  | "denshikozu"
  | "chiekikenzumen"
  | "tatemonozumen";

/**
 * 種別セルの (フィールド, 表示名) 対。
 * 並び＝テーブル列順＝登記取得日フォールバック順（全部事項を最優先）。
 */
export const PICTURE_CELL_FIELD_LABELS: ReadonlyArray<
  readonly [PictureCellField, string]
> = [
  ["zenbujiko", "全部事項"],
  ["shoyushajiko", "所有者事項"],
  ["denshikozu", "電子公図"],
  ["chisekisokuryozu", "地積測量図"],
  ["chiekikenzumen", "地役権図面"],
  ["tatemonozumen", "建物図面"],
];
